import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { LoaderPageContainer, toast } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import { useNavigate } from 'react-router-dom';
import Countdown from 'react-countdown';
import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import LogoutButton from 'src/components/shared/LogoutButton';
import { useStore } from 'src/stores';
import sentMessage from 'src/img/sent-message-big.svg';
import useStyles from './styles';
import moment from 'moment';
export default function ProfileSavedPage() {
  const store = useStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Profile Saved';
  const isNotConfirmedUser = !!localStorage.getItem(USER_SETTINGS_KEYS.confirmation);
  const _useState = useState(isNotConfirmedUser ? false : true),
    _useState2 = _slicedToArray(_useState, 2),
    isCountdown = _useState2[0],
    setCountdown = _useState2[1];
  const _useState3 = useState(isNotConfirmedUser ? false : true),
    _useState4 = _slicedToArray(_useState3, 2),
    isSend = _useState4[0],
    setSend = _useState4[1];
  const userEmail = isNotConfirmedUser ? localStorage.getItem(USER_SETTINGS_KEYS.confirmation) : parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken)).email;
  const resendCode = async () => {
    var _store$account$resend;
    setSend(true);
    track(events.clicked('Resend Email'), {
      page
    });
    const resp = await store.account.resendCodeToConfirmAccountEmailAsync.run({
      email: userEmail
    });
    if (((_store$account$resend = store.account.resendCodeToConfirmAccountEmailAsync) === null || _store$account$resend === void 0 || (_store$account$resend = _store$account$resend.error) === null || _store$account$resend === void 0 ? void 0 : _store$account$resend.errorCode) === 'AccountAlreadyConfirmed') {
      toast('error', store.account.resendCodeToConfirmAccountEmailAsync.error.errorResp);
      setTimeout(() => {
        store.auth.reset();
        navigate('/login');
      }, 3000);
      return;
    }
    if (resp && resp.isSuccessful) {
      setCountdown(true);
      return;
    }
    setSend(false);
  };
  const changeUserData = () => {
    store.auth.reset();
    navigate('/');
    track(events.clicked('Edit Email'), {
      page
    });
  };
  const countdownFinished = () => {
    setCountdown(false);
    setSend(false);
  };
  const getResentTimerForCountdown = () => {
    return moment().add('3', 'minutes').valueOf() - 1000; // 2 min 59 sec
  };
  useEffect(() => {
    return () => {
      localStorage.removeItem(USER_SETTINGS_KEYS.confirmation);
    };
  }, []);
  return /*#__PURE__*/React.createElement(LoaderPageContainer, null, /*#__PURE__*/React.createElement(LogoutButton, null), /*#__PURE__*/React.createElement("div", {
    className: classes.successBlockWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: sentMessage,
    width: "248",
    height: "200",
    alt: "icon message sent"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    marginBottom: "18px",
    marginTop: "32px"
  }, isNotConfirmedUser ? t('general.welcome_back') : t('general.profile_saved')), isNotConfirmedUser && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    marginBottom: "18px",
    className: classes.additionalInfo
  }, t('sign_up_flow.not_yet_confirmed_email')), !isNotConfirmedUser && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    marginBottom: "10px",
    className: classes.additionalInfo
  }, t('sign_up_flow.confirmation_sent')), isCountdown && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    marginBottom: "0",
    className: classes.additionalInfo
  }, t('sign_up_flow.did_not_get_confirmation'), /*#__PURE__*/React.createElement(Countdown, {
    date: getResentTimerForCountdown(),
    onComplete: countdownFinished,
    renderer: _ref => {
      let minutes = _ref.minutes,
        seconds = _ref.seconds;
      if (minutes === 0) {
        return /*#__PURE__*/React.createElement("span", null, " ".concat(seconds, " ").concat(t('general.seconds'), " "));
      } else {
        return /*#__PURE__*/React.createElement("span", null, " ".concat(minutes, " ").concat(t('general.minutes'), " ").concat(seconds, " ").concat(t('general.seconds'), " "));
      }
    }
  }), t('sign_up_flow.happy_to_resend')), !isNotConfirmedUser && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    marginBottom: "30px",
    className: classes.additionalInfo
  }, t('sign_up_flow.wrong_information'), ' ', /*#__PURE__*/React.createElement("span", {
    onClick: changeUserData,
    className: classes.controller,
    'custom-attribute': '726-profile-saved-page'
  }, t('sign_up_flow.re-enter_information'))), userEmail && /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: resendCode,
    disabled: isSend,
    'custom-attribute': '725-profile-saved-page'
  }, t('buttons.resend_email'))));
}